// QR Kiosk v2 — KV2-3 red validation-summary card (ticket §1.5 shared atom).
// Presentational only. Static title + hint (no dynamic "N missing" count — the inline
// FieldError rows already enumerate the misses; KV2-3-f). Tokens only.
import React from "react";

export interface ValidationSummaryProps {
  title: string;
  hint: string;
}

export function ValidationSummary({ title, hint }: ValidationSummaryProps) {
  return (
    <div
      style={{
        margin: 0, // parent spaces it
        borderRadius: 11,
        border: "1px solid color-mix(in oklab, var(--red) 40%, var(--border))",
        background: "color-mix(in oklab, var(--red) 9%, var(--card))",
        padding: "10px 13px",
      }}
    >
      <div style={{ fontSize: 13, fontWeight: 700, color: "color-mix(in oklab, var(--red) 82%, var(--ink))" }}>{title}</div>
      <div style={{ fontSize: 12, color: "var(--ink-2)", marginTop: 2 }}>{hint}</div>
    </div>
  );
}

export default ValidationSummary;
